import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { SiGmail } from "react-icons/si";
import { Facebook, Instagram, Whatsapp } from "react-bootstrap-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import SEO from "../components/SEO";

function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <SEO
        title="Contact Coach Julius Adeleke - Adeleke Tennis Academy"
        description="Get in touch with Julius Adeleke for professional tennis coaching in the US. Book lessons or ask about Adeleke Tennis Academy programs."
        keywords="Contact Julius Adeleke, Tennis Coaching Contact, Adeleke Tennis Academy Contact"
        url="https://www.adeleketennisacademy.com/contact"
        image="https://julius-s-adeleke.web.app/public/julius.jpg"
      />

      <section
        id="contact"
        className="py-5 text-white"
        style={{ backgroundColor: "#000" }}
      >
        <Container style={{ maxWidth: "1100px" }}>

          {/* HEADER */}
<div className="text-center mb-5 px-3 px-md-0">

  <div style={{ marginTop: "20px" }} className="d-block d-md-none" />

  <div className="text-white mt-4 mt-md-5">
    <h3 className="fw-bold mb-3 fs-4 fs-md-2" style={{marginTop: "30px"}}>
      Need help? <span style={{ color: "yellow" }}>Say Hello</span>
    </h3>

    <p style={{ opacity: 0.8, fontSize: "0.95rem" }}>
      Reach out for coaching inquiries, training programs, or collaborations.
    </p>
  </div>

  <h6 className="mt-4 mt-md-5 text-uppercase text-secondary text-start text-md-start">
    Get In Touch
  </h6>

  <h2 className="fw-bold mb-4 text-white text-start text-md-start fs-5 fs-md-3">
    Contact Me
  </h2>

</div>
            
        

          <Row className="g-5">

            {/* CONTACT INFO */}
            <Col xs={12} md={4} data-aos="fade-up">

              <h5 className="fw-bold mb-4">Contact Info</h5>

              <div className="mb-3">
                <SiGmail className="me-2" />
                <a
                  href="mailto:juliussunday909@gmail.com"
                  className="text-white text-decoration-none"
                >
                  Email Me
                </a>
              </div>

              <div className="mb-3">
                <Whatsapp className="me-2 text-success" />
                <a
                  href="https://wa.me/+18625764553"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  WhatsApp Chat
                </a>
              </div>

              <div className="mb-2">
                <Facebook className="me-2 text-primary" />
                <a
                  href="https://web.facebook.com/julisky06"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  Facebook
                </a>
              </div>

              <div>
                <Instagram className="me-2 text-danger" />
                <a
                  href="https://www.instagram.com/AdelekeTennisAcademy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  Instagram
                </a>
              </div>

            </Col>

            {/* FORM */}
            <Col xs={12} md={8} data-aos="fade-up">

              <Card
                className="border-0 shadow-lg p-4"
                style={{
                  backgroundColor: "#111",
                  borderRadius: "12px",
                }}
              >
                <Card.Body>

                  <h5 className="mb-4 fw-bold">Send a Message</h5>

                  <Form
                    action="https://formsubmit.co/juliussunday909@gmail.com"
                    method="POST"
                  >
                    {/* FormSubmit settings */}
                    <input type="hidden" name="_captcha" value="false" />
                    <input type="hidden" name="_template" value="table" />
                    <input type="hidden" name="_subject" value="New Contact Message" />
                    <input
                      type="hidden"
                      name="_autoresponse"
                      value="Thanks for contacting me! I’ll get back to you soon."
                    />

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        name="subject"
                        placeholder="Subject"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="message"
                        placeholder="Write your message..."
                        required
                      />
                    </Form.Group>

                    <Button
                      variant="warning"
                      type="submit"
                      className="w-100 fw-bold"
                    >
                      Send Message
                    </Button>

                  </Form>
                </Card.Body>
              </Card>

            </Col>

          </Row>
        </Container>
      </section>
    </>
  );
}

export default Contact;